import getJSONFromFile from '@/_core/util/fileUtility.js';

const localeConfig = require('@/_config/locale/supported-locales.json');
const { locales, rtl } = getJSONFromFile(localeConfig);

const supportedLocales = locales;

export function getSupportedLocales() {
  // eslint-disable-next-line prefer-const
  let annotatedLocales = [];

  for (const code of Object.keys(supportedLocales)) {
    annotatedLocales.push({
      code,
      name: supportedLocales[code],
    });
  }

  return annotatedLocales;
}

export function supportedLocalesInclude(locale) {
  return Object.keys(supportedLocales).includes(locale);
}

export function supportedLocaleWithRTLSupport() {
  return rtl;
}
